<template>
  <div v-if="dialog.visible" class="sort-box">
  <!-- 出现排序的模态框 -->
  <el-dialog :title="dialog.title"
             :visible.sync="dialog.visible"
             width="386px"
             center
             class="sort-dialog"
             :close-on-click-modal="false"
            @close="clearCurrentClick"
             append-to-body>
      <div class="modal-body">
        <ul class="modal-body-ul">
          <draggable v-model="sortList">
            <transition-group>
                <li class="modal-body-li"
                      v-for="(col,index) in sortList"
                      @click="currentClickSortList(col.id)"
                      :key='index'
                      :class="dialog.isClick === col.id ? 'sort-button':'' ">
                    <div class="column-name" :class="dialog.isClick === col.id ? 'click-column':'' ">{{col.name}}</div>
                    <span class="up" @click="upSortList(index)"></span>
                    <span class="down" @click="downSortList(index)"></span>
                  </li>
            </transition-group>
          </draggable>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveSortList">保 存</el-button>
        <el-button @click="dialog.visible = false">取 消</el-button>
      </span>
  </el-dialog>
  </div>
</template>
<script>
export default {
  props: ['dialog'],
  data () {
    let sortList = this.$_.cloneDeep(this.dialog.sortLists)
    return {
      sortList
    }
  },
  methods: {
    saveSortList () {
      this.$emit('saveSortList', this.sortList)
    },
    upSortList (index) {
      if (index > 0) {
        let sortList = this.sortList
        sortList.splice(index - 1, 1, ...sortList.splice(index, 1, sortList[index - 1]))
      }
    },
    // 点击和当前下一个互换位置
    downSortList (index) {
      if (index < this.sortList.length - 1) {
        let sortList = this.sortList
        sortList.splice(index, 1, ...sortList.splice(index + 1, 1, sortList[index]))
      }
    },
    currentClickSortList (id) {
      this.dialog.isClick = id
    },
    clearCurrentClick () {
      this.dialog.isClick = ''
    }
  }
}
</script>
<style lang="scss">
.sort-dialog {
    .el-dialog {
      min-width: 386px;
      .el-dialog__body {
        padding: 20px 10px 20px 25px;
      }
      .modal-body {
        position: relative;
        overflow-y: auto;
        min-height: 121px;
        max-height: 514px;
        margin-left: 13px;

        .modal-body-ul {
          li {
            margin: 8px auto;
            height: 28px;
            line-height: 28px;
            position: relative;
            border-radius: 4px;
            cursor: pointer;

            .column-name {
              padding-left: 8px;
              background: #f4f4f4;
              width: 94%;
            }
            .click-column{
              background-color: #ebf6ff;
            }
            span {
              width: 16px;
              height: 16px;
              position: absolute;
              right: 18%;
              top: 50%;
              margin-top: -8px;
              font-size: 24px;
              display: none;
            }
            .up{
              background-image: url("./assets/sort-arrow-upN.png");
            }
            .up:hover{
              background-image: url("assets/sort-arrow-upA.png");
            }
            .down {
              right: 27%;
              background-image: url("./assets/sort-arrow-downN.png");
            }
            .down:hover{
              background-image: url("./assets/sort-arrow-downA.png");
            }
            .delete{
              right: 9%;
              background-image: url("./assets/sort-arrow-delete.png");
            }
            .delete:hover{
              background-image: url("./assets/sort-arrow-deleteA.png");
            }
            &:nth-child(1) {
              .up {
                background-image: url("./assets/sort-arrow-upD.png");
              }
            }
            &:last-of-type {
              .down {
                color: #b7b7b7;
                background-image: url("./assets/sort-arrow-downD.png");
              }
            }
          }
          .sort-button{
            span{
              display: inline-block;
            }
          }
        }
      }
      .el-button {
        padding: 8px 35px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/design/sort.vue